// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton_closeButton__2SZ0m","closeIcon":"CloseButton_closeIcon__26cPI"};